module.exports = __webpack_public_path__ + "img/lqsxtou_1.3d84f89c.svg";